import {
    SET_SERVICE,
    DEFAULT_NOT_AUTH_PATH,
    SET_AUTH,
    SET_LOADING_INFO,
    SET_USER_LOGIN_INFO,
    SET_MAINTENANCE_MODE,
    SET_USER_LOCALIZATION,
    APP_TYPE_ADMIN,
    DEFAULT_AUTH_PATH_ADMIN,
    DEFAULT_AUTH_PATH_CLIENT,
    HAS_BOTH_SERVICE_VALUE,
    SET_INITED_REFERENCFES,
    SET_CAPTCHA_NEEDED
} from "const";
import {
    langFullNames,
    DEFAULT_ERROR_MESSAGE,
    SET_INFO_ACCOUNT
} from "const";


import { login, login2FA, logout } from "api/auth";
import { createAction } from "./defaults";
import { setRoles } from "./index";
import history from "config/history";
import { NEED_SECOND_AUTH, SET_PERMISSION } from "./actionTypes";
import { api } from "api/loginRoutes";
import { Alert } from "rsuite";
import {
    LOCAL_STORAGE_USER_INFO,
    LS_SESSION_EXPIRED,
    LS_LAST_SERVICE,
    LS_LAST_PAGE
} from "const/localStorageKeys";
import {
    ACCOUNT_USER_GET_SESSION_DIALER_API,
    SET_RULES_ACCEPT,
    SET_PRIVACY_ACCEPT,
    ACCOUNT_USER_LOGIN_CHECK_CAPTCHA_NEEDED_API
} from "const/apiMethods";


export const setAuth = (payload, appType = false, clearPermissions = true) => ({ type: SET_AUTH, payload, appType, clearPermissions });

const setLoading = createAction(SET_LOADING_INFO);
const setInfoAccount = createAction(SET_INFO_ACCOUNT);
const setUserLoginInfo = createAction(SET_USER_LOGIN_INFO);
const setMaintenanceModeAction = createAction(SET_MAINTENANCE_MODE);
const setSecondAuthType = createAction(NEED_SECOND_AUTH);
const setUserLocals = createAction(SET_USER_LOCALIZATION);
const setRulesNotAccepted = createAction(SET_RULES_ACCEPT);
const setPrivacyNotAccepted = createAction(SET_PRIVACY_ACCEPT);
const setInited = createAction(SET_INITED_REFERENCFES);
const setCaptchaNeeded = createAction(SET_CAPTCHA_NEEDED);

export const setServiceAction = createAction(SET_SERVICE);

const isCaptchaTokenRequiredError = (response) => {
    const responseError = response?.response?.data?.error || response?.data?.error;

    return responseError?.data === "need captcha_token";
};

export const setMaintenanceMode = (value) => (dispatch) => {
    dispatch(setMaintenanceModeAction(value));
    if (value) {
        localStorage.removeItem("api_key");
        localStorage.removeItem(LOCAL_STORAGE_USER_INFO);
        dispatch(setAuth(false));
        dispatch(setInfoAccount(null));
    }
};


export const loginBySessionKey = (id) => (dispatch) => {
    localStorage.setItem("api_key", id);

    api(ACCOUNT_USER_GET_SESSION_DIALER_API)
        .then(r => {
            if (!r?.session?.session_key) {
                localStorage.removeItem("api_key");
                history.push(DEFAULT_NOT_AUTH_PATH);
                return;
            }

            const sessionSite = r.session.site;
            const sessionLang = "en";
            const sessionLRtl = sessionLang === "ar";

            // save data in LocalStorage
            localStorage.setItem("lang", sessionLang);
            localStorage.setItem("rtl", sessionLRtl);
            localStorage.setItem("api_key", r.session.session_key);
            localStorage.setItem("userInfo", JSON.stringify(r));

            dispatch(setUserLoginInfo(r));
            dispatch(setRoles(r.session.account_user.role_list));
            dispatch(setUserLocals({ lang: sessionLang, rtl: sessionLRtl }));
            dispatch(setAuth(true, sessionSite, false));

            if (sessionSite === APP_TYPE_ADMIN) {
                history.push(DEFAULT_AUTH_PATH_ADMIN);
                return;
            }

            const accountList = r.session?.account_list || [];

            if (accountList.length === 1 && accountList[0]?.service === "sms") {
                history.push(`${DEFAULT_AUTH_PATH_CLIENT}-sms`);
                return;
            }

            history.push(`${DEFAULT_AUTH_PATH_CLIENT}-voice`);
        });
};

export const loginUser = ({ lang = "en", loginHistory, loginLocation, ...data }) => (dispatch, getState) => {
    const isSecondFactor = Object.prototype.hasOwnProperty.call(data, "second_password");
    const { loading, secondAuthType } = getState().auth;

    if (loading || (isSecondFactor && !secondAuthType)) {
        return Promise.resolve();
    }

    dispatch(setLoading(true));
    let secondFactorAuthenticated = false;

    const loginRecently = JSON.parse(sessionStorage.getItem("login_recently"));
    const logoutRecently = JSON.parse(sessionStorage.getItem("logout_recently"));

    // const history = loginHistory ? loginHistory : history;

    const h = loginHistory || history;
    const method = isSecondFactor ? login2FA : login;

    return method(data)
        .then((response) => {
            if (!response) {
                return;
            }

            if (!isSecondFactor && isCaptchaTokenRequiredError(response)) {
                Alert.error("Please reload the page and try again");
                return response;
            }

            const result = response?.data?.result || {};

            if (isSecondFactor && (response?.data?.error || !result?.session?.site || !result?.session?.session_key)) {
                return response;
            }

            const secondAuthType = result.second_authentication_type;

            sessionStorage.setItem("secondAuth", !!secondAuthType);

            if (secondAuthType) {
                dispatch(setSecondAuthType({
                    secondAuthType: secondAuthType === 1
                        ? "email"
                        : "phone",
                    secondAuthLink: secondAuthType === 1
                        ? result.email
                        : result.phone,
                    secondAuthEmail: result.email
                }));

                return;
            }

            const sessionSite = result?.session?.site;

            const storedSessionSite = sessionStorage.setItem("sessionSite", sessionSite);

            if (!sessionSite) {
                if (result?.reason) {
                    Alert.error(result.reason);
                }

                return;
            }

            const sessionLang = sessionSite === APP_TYPE_ADMIN ? "en" : lang;
            const sessionLRtl = sessionLang === "ar";
            const isTest = result.session.is_test;

            // save data in LocalStorage
            localStorage.setItem("lang", sessionLang);
            localStorage.setItem("rtl", sessionLRtl);
            localStorage.setItem("api_key", result.session.session_key);
            localStorage.setItem("userInfo", JSON.stringify(result));

            sessionStorage.setItem("lastAuth", Date.now());

            dispatch(setUserLoginInfo(result));
            dispatch(setRoles(result.session.account_user.role_list));
            dispatch(setUserLocals({ lang: sessionLang, rtl: sessionLRtl }));
            dispatch(setAuth(true, sessionSite));
            secondFactorAuthenticated = isSecondFactor;
            // dispatch( setInited(false) );

            const roleList = result.session.account_user.role_list;
            // const isRatemod = roleList.includes("Ratemod");
            // const isRatemodSms = roleList.includes("Ratemod (sms)");

            return response;
        })
        .catch((error) => {
            if (isSecondFactor) {
                return error;
            }

            dispatch(setAuth(false));

            const reasonCode = error?.response?.data?.error?.reason_code;
            if (!reasonCode) {
                Alert.error(error?.response?.data?.error?.data?.error_type || DEFAULT_ERROR_MESSAGE);
            }

            return error;
        })
        .finally(() => {
            const secondFactorFailed = isSecondFactor && !secondFactorAuthenticated;

            if (secondFactorFailed) {
                localStorage.removeItem("api_key");
                localStorage.removeItem(LOCAL_STORAGE_USER_INFO);
                sessionStorage.removeItem("secondAuth");
                dispatch(setAuth(false));
                h.replace(DEFAULT_NOT_AUTH_PATH);
                Alert.error("Two-factor authentication failed. Please sign in again.");
            }

            const location = (!loginRecently || (!loginRecently && logoutRecently)) ? h.location : loginLocation;
            // !logoutRecently 
            const isSecondAuth = JSON.parse(sessionStorage.getItem("secondAuth"));

            if (!isSecondAuth) {
                extraHistoryPush(secondFactorFailed ? DEFAULT_NOT_AUTH_PATH : location.pathname)
                    .finally(() => {
                        localStorage.removeItem(LS_SESSION_EXPIRED);
                        dispatch(setLoading(false));
                    })
            }
            dispatch(setLoading(false));

            sessionStorage.removeItem("logout_recently");
            sessionStorage.setItem("login_recently", true);
            sessionStorage.removeItem("secondAuth");
        })
};

const extraHistoryPush = (path) => {
    return new Promise((resolve, reject) => {
        if (path === "/login") {
            resolve(path);
        } else {
            reject();
        }
    })
};

const checkIfDateNotLate = (date, minutes) => {
    if (date) {
        const lastAuth = parseInt(date); // повертає мілісекунди
        const now = Date.now();
        const hoursInMs = minutes * 60 * 1000;

        if (now - lastAuth > hoursInMs) {
            return false;
        } else {
            return true
        }
    }

    return false;
};

export const rulesAccept = (lang) => (dispatch) => {
    const savedAuthInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {};
    localStorage.setItem("userInfo", JSON.stringify({ ...savedAuthInfo, "rules_not_accepted": false }));

    api(SET_RULES_ACCEPT, { language: langFullNames[lang] }).then(() => {
        dispatch(setRulesNotAccepted(false));
    });
};


export const privacyAccept = (lang) => (dispatch) => {
    const savedAuthInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {};
    localStorage.setItem("userInfo", JSON.stringify({ ...savedAuthInfo, "privacy_not_accepted": false }));

    api(SET_PRIVACY_ACCEPT, { language: langFullNames[lang] }).then(() => {
        dispatch(setPrivacyNotAccepted(false));
    });
};

export const getPermission = () => (dispatch) => {
    return api("permitted_methods")
        .then((resp) => {
            dispatch({ type: SET_PERMISSION, payload: resp });
            return resp;
        })
        .catch((e) => {
            throw e;
        });
};


export const logoutUser = () => async (dispatch) => {
    dispatch(setServiceAction(true));

    await logout();

    sessionStorage.removeItem("login_recently");
    sessionStorage.setItem("logout_recently", true);

    // if (sessionStorage.getItem("lastAuth")) {
    //     sessionStorage.removeItem("lastAuth");
    // }

    dispatch(setServiceAction(true));

    localStorage.removeItem("lang");
    localStorage.removeItem("rtl");

    localStorage.removeItem("api_key");
    localStorage.removeItem(LOCAL_STORAGE_USER_INFO);
    localStorage.removeItem(HAS_BOTH_SERVICE_VALUE);

    Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("CURRENT_SUPPLIER")) {
            localStorage.removeItem(key);
        }
    });

    dispatch(setAuth(false));
    dispatch(setInited(false));
    dispatch(setInfoAccount(null));

    history.push({
        pathname: DEFAULT_NOT_AUTH_PATH
    });
};

export const clearSession = () => {
    localStorage.removeItem(LS_SESSION_EXPIRED);
    localStorage.removeItem(LS_LAST_PAGE);
    localStorage.removeItem(LS_LAST_SERVICE);
    localStorage.removeItem("userInfo");
    localStorage.removeItem("api_key");
    localStorage.removeItem("HAS_BOTH_SERVICE_VALUE");
    localStorage.removeItem("lang");
    sessionStorage.removeItem("login_recently");
};

export const ping = () => async (dispatch) => {
    const res = await api("ping");

    if (res instanceof Error || !res.ip)
        return false;

    dispatch(setMaintenanceModeAction(false));
    return true;
};

export const setService = (service) => (dispatch) => {
    dispatch(setServiceAction(service));
};

export const changeLanguage = (lang, rtl = false) => (dispatch) => {
    // localStorage.setItem("rtl", rtl);
    dispatch(setUserLocals({ lang, rtl }));
};

export const checkCaptchaNeeded = () => async (dispatch) => {
    await api(ACCOUNT_USER_LOGIN_CHECK_CAPTCHA_NEEDED_API)
        .then(({ captcha_needed }) => {
            dispatch(setCaptchaNeeded(captcha_needed));
        })
};
